import React from "react";

export interface Row{
    children: React.ReactNode;
}

export const Row: React.FC<Row> = ({children}) => {
    return (<div className='rows-grey-separator__row'>
        {children}
    </div>);
};
export interface RowsGreySeparator {
    children: React.ReactNode;
}

export const RowsGreySeparator: React.FC<RowsGreySeparator> = ({children}) => {
    return (<div className='rows-grey-separator'>
        {children}
    </div>);
};
